import React from "react";
import UserLoginsGrid from "./UserLogins/UserLoginsGrid";
import UserPermissions from "./UserPermissions/UserPermissions";
import { useState, useRef, useEffect } from "react";
import { getStorageItem } from "../../../Common/Utility";

export default function UserManagement() {
  const [selectedUserId, setSelectedUserId] = useState(1);
  const [selectedUserName, setSelectedUserName] = useState("Admin");
  const [isAdmin, setIsAdmin] = useState(false);
  const previousSelectionRef = useRef(null);

  useEffect(() => {
    (async () => {
      const admin = await getStorageItem("login", "isAdmin");
      setIsAdmin(!!admin);
    })();
  }, []);

  const handleUserSelected = (userId, userName) => {
    setSelectedUserId(userId);
    setSelectedUserName(userName);
  };

  const handleAddNewStarted = () => {
    previousSelectionRef.current = {
      userId: selectedUserId,
      userName: selectedUserName,
    };
    setSelectedUserId(0);
    setSelectedUserName("");
  };

  const handleEditOrAddCancelled = () => {
    const prev = previousSelectionRef.current;
    if (prev) {
      setSelectedUserId(prev.userId);
      setSelectedUserName(prev.userName);
      previousSelectionRef.current = null;
    }
  };

  return (
    <>
      <UserLoginsGrid
        onSelectUser={handleUserSelected}
        onAddNewStarted={handleAddNewStarted}
        onEditOrAddCancelled={handleEditOrAddCancelled}
      />

      <UserPermissions
        UserId={selectedUserId}
        UserName={selectedUserName}
        isAdmin={isAdmin}
      />
    </>
  );
}
